import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular/lazy';
import { PermissionsModule } from '@app/lib/b2b-pipes/permissions/permissions.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [],
  imports: [],
  exports: [
    CommonModule,
    IonicModule,
    PermissionsModule,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class SharedModule {}
